module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"valid_message_length":"(Valid chars: {0})"}}')
  delete Component.options._Ctor
}
